import { useMsal } from '@azure/msal-react';

export const useAuth = () => {
   const { accounts } = useMsal();
   const claims = accounts[0]?.idTokenClaims;

   const isAdmin = claims?.roles?.includes('admin') ?? false;
   const isEditor = claims?.roles?.includes('editor') ?? false;
   const isViewer = claims?.roles?.includes('viewer') ?? false;
   const isEmission = claims?.roles?.includes('emission') ?? false;
   const canEdit = isAdmin || isEditor;
   const canManageEmissionFactors = isAdmin || isEmission;
   const hasRole = isAdmin || isEditor || isViewer || isEmission;

   return { isAdmin, isEditor, isViewer, isEmission, canEdit, canManageEmissionFactors, hasRole };
};
